import { Pipe, PipeTransform } from '@angular/core';
import { RecurringPaymentAmountTypeEnum } from '../../../../../models/enum/shared/recurring-payment-amount-type.enum';

@Pipe({
  name: 'recurringPaymentAmountTypeName'
})
export class RecurringPaymentAmountTypeNamePipe implements PipeTransform {
  transform(value: RecurringPaymentAmountTypeEnum | null | undefined): string {
    switch (value) {
      case RecurringPaymentAmountTypeEnum.Custom:
        return $localize`Custom`;
      case RecurringPaymentAmountTypeEnum.Minimum:
        return $localize`Minimum`;
      default:
        return '';
    }
  }
}
